export const ORGANIZATION_NAME_MAX_LENGTH = 255;
export const ORGANIZATION_TEXT_AREA_MAX_LENGTH = 500;
export const ORGANIZATION_INPUT_MAX_LENGTH = 100;
export const ORGANIZATION_PHONE_MAX_LENGTH = 15;
export const EMAIL_REGEX_VALIDATION = /^\S+@\S+$/i;
export const PHONE_REGEX_VALIDATION = /^\+?[1-9]\d{1,14}$/;
export const DESCRIPTION_TEXT_AREA_MAX_LENGTH = 255;
export const ORGANIZATION_FISCAL_ID_MIN_LENGTH = 3;
export const ORGANIZATION_EXTERNAL_ID_INPUT_MAX_LENGTH = 50;
